module.exports = __webpack_public_path__ + "img/ikapi.369c9c6e.png";